<template>
  <v-container fluid>
    <VistaEnviosAdmin v-if="logedInUserInfo.rol==1" />
    <VistaEnviosMostrador v-else/>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import VistaEnviosAdmin from "@/components/HistorialEnviosAdmin.vue";
import VistaEnviosMostrador from "@/components/HistorialEnviosMostrador.vue";
export default {
  name:"HistorialEnvios",
  data:()=>({}),
  components:{
    VistaEnviosAdmin,
    VistaEnviosMostrador
  },
  computed:{
    ...mapState({
      logedInUserInfo: (state) => state.sesion.logedInUserInfo,
    }),
  }
}
</script>